import { anyOf } from '@/router/routeMeta.js';
import { RoleGroups, Roles } from '@/router/roles';
import { stores } from '@/util/stores.js';

export const employeeRoutes = [
	{
		path: 'employee/announcements',
		name: 'Announcements',
		meta: anyOf(Roles.EVERGREEN),
		beforeEnter: () => stores.usersStore.hasRole([Roles.EVERGREEN]) || { name: 'Private Access Denied' },
		component: () => import('@/views/EvergreenSports/Announcements/AnnouncementsPage.vue')
	},
	{
		path: 'employee',
		name: 'Employee Dashboard',
		meta: anyOf(RoleGroups.EMPLOYEE),
		component: () => import('@/views/EvergreenSports/Dashboard/EmployeeDashboard.vue')
	},
	{
		path: 'employee/directory',
		name: 'Employee Directory',
		meta: anyOf(RoleGroups.EMPLOYEE),
		component: () => import('@/views/UsersDatatable/UserDirectory.vue')
	},
	{
		path: 'employee/group-signups',
		name: 'Group Signups',
		meta: anyOf(RoleGroups.EMPLOYEE),
		component: () => import('@/views/EvergreenSports/EGSGroups/GroupSignups/GroupSignups.vue')
	},
	{
		path: 'employee/stripe-connect',
		name: 'Stripe Connect Operations',
		meta: Roles.EVERGREEN,
		component: () => import('@/finance/views/ops/PaymentsOps.vue')
	},
	{
		path: 'employee/onboarding-preview',
		name: 'Onboarding Preview',
		meta: anyOf(RoleGroups.EMPLOYEE),
		component: () => import('@/views/EvergreenSports/EGSGroups/Onboarding/OnboardingComponents.vue')
	},
	{
		path: 'onboarding/:token',
		name: 'Onboarding Wizard',
		meta: { auth: true },
		component: () => import('@/views/Onboarding/OnboardingWizard.vue'),
		props: true
	},
	{
		path: 'employee/locations',
		name: 'Locations',
		meta: Roles.EVERGREEN,
		component: () => import('@/views/EvergreenSports/Locations/Locations.vue')
	},
	{
		path: 'employee/groups',
		name: 'Employee Groups',
		meta: Roles.EVERGREEN,
		component: () => import('@/views/EvergreenSports/EGSGroups/EGSGroups.vue')
	},
	{
		path: 'employee/emails',
		name: 'Employee Email Dashboard',
		meta: Roles.EVERGREEN,
		component: () => import('@/views/EvergreenSports/Email/EmailDashboard.vue')
	}
];
